// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"e49e82c2","455":"9404177d","977":"d43510f2"}[chunkId] + ".chunk.js";
};